import { Theme } from '@material-ui/core';
import { ButtonClassKey } from '@material-ui/core/Button';

const MuiButton = (theme: Theme): Partial<Record<ButtonClassKey, unknown>> => ({
    outlined: {
        padding: '7px 31px',
    },
    contained: {
        color: theme.palette.text.primary,
        padding: '8px 32px',
    },
    text: {
        padding: '8px 32px',
    },
    outlinedSizeSmall: {
        padding: '3px 31px',
    },
    outlinedSizeLarge: {
        padding: '11px 31px',
        fontSize: '1.250rem',
    },
    containedSizeSmall: {
        padding: '4px 32px',
    },
    containedSizeLarge: {
        padding: '12px 32px',
        fontSize: '1.250rem',
    },
    textSizeSmall: {
        padding: '4px 32px',
    },
    textSizeLarge: {
        padding: '12px 32px',
        fontSize: '1.250rem',
    },
});

export default MuiButton;
